export default class MenuItem {
  constructor(config = {}) {

    const routeMeta = config.route && config.route.meta ? config.route.meta : {};

    this.count = config.count || null;
    this.cta = config.cta || false;
    this.divider = config.divider || false;
    this.hideTitle = config.hideTitle || false;
    this.href = config.href || null;
    this.icon = config.icon || routeMeta.icon || null;
    this.iconPack = config.iconPack || null;
    this.imageUrl = config.imageUrl || null;
    this.menuItems = config.menuItems ? config.menuItems.map(menuItem => new MenuItem(menuItem)) : [];
    this.onClick = config.onClick || null;
    this.route = config.route || {}; // Vue Router Route
    this.secondaryMenuActive = config.secondaryMenuActive || false;
    this.target = config.target || null;
    this.title = config.title || routeMeta.title || '';
    this.when = config.when !== undefined ? config.when : null;
  }

  get shouldShowTitle() {
    return this.title && !this.hideTitle;
  }
}
